export default {"src":"/_next/static/media/oven.9c270c9f.svg","height":100,"width":100};